module.exports = __webpack_public_path__ + "media/images/th-icon-4c2968530d512630eea9a27ed80f1be7.png";